__turbopack_context__.v({
  "className": "gGBaTW_className",
  "variable": "gGBaTW_variable",
});
